/*
 * MDB shim for MDBTableHead
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountList.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx
 * - src/Seating/PurchaseQueue/inventoryRequest.jsx
 * - src/Seating/PurchaseQueue/inventoryRequestTable.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueTable.jsx
 * - src/Seating/Settings/creditCardTypes.jsx
 * - src/Seating/Settings/deliveryAcknowledgements.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/expenseTypes.jsx
 * - src/Seating/Settings/reasons.jsx
 * - src/Seating/Settings/trainingLink.jsx
 */

import MUITableHead from "@mui/material/TableHead";
import MUITableCell from "@mui/material/TableCell";
import MUITableRow from "@mui/material/TableRow";

export default function MDBTableHead({ children, columns, ...rest }) {
  if (children) {
    return (
      <MUITableHead sx={{ fontWeight: "bold" }} {...rest}>
        {children}
      </MUITableHead>
    );
  }

  if (columns.length > 0 && columns !== undefined) {
    return (
      <MUITableHead sx={{ fontWeight: "bold" }} {...rest}>
        <MUITableRow>
          {columns.map((column) => (
            <MUITableCell sx={{ textAlign: "center" }} key={column.field}>
              {column.label}
            </MUITableCell>
          ))}
        </MUITableRow>
      </MUITableHead>
    );
  }
}
